// extracted by mini-css-extract-plugin
module.exports = {"notification":"Notification_notification__pERJa","button":"Notification_button__2Xn8q","primary":"Notification_primary__1Qe8S"};